import { Injectable } from '@angular/core';
import { Building } from '../../models/building.model';
import { BaseService } from './base.service';
import { Observable } from 'rxjs';

@Injectable({
  providedIn: 'root'
})
export class BuildingService extends BaseService<Building>  {

  protected readonly endpointUri = 'Buildings';

  getAll(): Observable<any> {
    return this.getAllRequest();
  }

  get(id: string): Observable<any> {
    return this.getRequest(id);
  }

  /**
   * Return buildings with associated visible rooms
   *
   * @param {string} id
   * @returns {Observable<any>}
   * @memberof BuildingService
   */
  getWithRooms(): Observable<any> {
    return this.getRequest(null, null, [{ key: 'hasRooms', value: 'true' }]);
  }

  add(entity: Building): Observable<any> {
    throw new Error('Method not implemented.');
  }

  update(entity: Building): Observable<any> {
    throw new Error('Method not implemented.');
  }

  delete(id: string): Observable<{}> {
    throw new Error('Method not implemented.');
  }

}
